import * as React from "react";
// style, design
import BaseTable from "src/components/Lists/Base/FinalTable/BaseTable";
import columnDefs from "./listDefs";

// store, state
import { buildRangeFilter } from "../../Lists/Base/utils";

import {
  useBrfInvoicingPagination,
  performFilter,
  constants,
  detailUrl,
} from "../../../store/invoicingBrf";

export default ({
  persistantQuery,
  isBare,
  ignoreLocalStorage,
  tableId,
  onRowClicked,
  checkRowHighlighted,
  onRowSelected,
}) => {
  const columns = React.useMemo(() => columnDefs(), [persistantQuery]);

  const filters = {};
  const badges = {};

  return (
    <BaseTable
      tableId={tableId || "brf_invoicing_full_table"}
      title={"Bostadsrätter"}
      onRowClickedWithDetail={(obj) =>
        detailUrl({
          id: obj.brf_contract.id,
        })
      }
      {...{
        isBare,
        ignoreLocalStorage,
        onRowClicked,
        columns,
        persistantQuery,
        badges,
        filters,
        constants,
        checkRowHighlighted,
        onRowSelected,
      }}
    />
  );
};
